import { useState, useEffect, useRef, useCallback } from 'react';
import "./Works.css";

const WORKS = [
    {
        id: 1,
        title: "QGIS BadApple",
        description: "QGISの地図キャンバス上で Bad Apple を再生するプラグイン",
        tags: ["Python", "PyQt5"],
        image: "/assets/images/works/qgis-badapple.png",
    },
    {
        id: 2,
        title: "ZIPPER MAN",
        description: "チェンソーマンをモチーフにしたZIPファイルを一括解凍するソフトウェア",
        tags: ["C#", ".NET Framework"],
        image: "/assets/images/works/Zipper-Man.png",
    },
    {
        id: 3,
        title: "nxtheme lib",
        description: "自作のNintendo Switchのカスタムテーマ",
        tags: ["C++"],
        image: "/assets/images/works/nxtheme-lib.png",
    },
    {
        id: 4,
        title: "Spotify Devious",
        description: "WebSpotifyの余計な要素を削除して、快適に利用するためのChrome拡張機能",
        tags: ["JavaScript"],
        image: "/assets/images/works/Spotify-Devious.png",
    },
    {
        id: 5,
        title: "LIBERAL CHART",
        description: "金沢工業大学のリベラルアーツ系科目の早見表",
        tags: ["React", "JavaScript"],
        image: "/assets/images/works/Liberal-Chart.png",
    },
    {
        id: 6,
        title: "緑のきゅうくらりん",
        description: "アニメーションの練習、緑のきゅうくらりんを作成",
        tags: ["Aviutl"],
        image: "/assets/images/works/Kyukurarin.png",
    },
    {
        id: 7,
        title: "トイレのポスター",
        description: "笑顔でイラつく女性がいる。遠回しに 綺麗に使え! と訴えるポスター",
        tags: ["Illustration"],
        image: "/assets/images/works/Toilet-Poster.png",
    },
];

const INTERVAL = 5000;

const Works = () => {
    const [current, setCurrent] = useState(0);
    const timerRef = useRef(null);
    const total = WORKS.length;

    const startTimer = useCallback(() => {
        timerRef.current = setInterval(() => {
            setCurrent((prev) => (prev + 1) % total);
        }, INTERVAL);
    }, [total]);

    const stopTimer = useCallback(() => {
        clearInterval(timerRef.current);
    }, []);

    useEffect(() => {
        startTimer();
        return () => stopTimer();
    }, [startTimer, stopTimer]);

    return (
        <section className="works-container" id="works">
            <h2>Works</h2>

            <div className="works-slider" onMouseEnter={stopTimer} onMouseLeave={startTimer}>
                <div className="works-track" style={{ transform: `translateX(-${current * 100}%)` }}>
                    {WORKS.map((work, i) => (
                        <div className="works-slide" key={work.id}>
                            <div className="works-image">
                                <img src={process.env.PUBLIC_URL + work.image} alt={work.title} />
                            </div>
                            <div className="works-info">
                                <span className="works-index">{String(i + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}</span>
                                <h3 className="works-title">{work.title}</h3>
                                <p className="works-description">{work.description}</p>
                                <div className="works-tags">
                                    {work.tags.map((tag) => (
                                        <span className="works-tag" key={tag}>{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="works-dots">
                {WORKS.map((_, i) => (
                    <span
                        key={i}
                        className={`works-dot ${i === current ? 'active' : ''}`}
                    />
                ))}
            </div>
        </section>
    );
}

export default Works;